import ENDPOINTS from "./endpoints";
import { request } from "./helpers";

/** Client-side maintenance check (e.g. maintenance page reload). Site-wide redirects use middleware. */
export async function checkMaintenanceMode() {
  try {
    const { data } = await request.get(ENDPOINTS.MAINTENANCE_STATUS);
    return data?.data?.maintenance_status === true;
  } catch {
    return false;
  }
}
